module.exports = (__webpack_require__(0))(27);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/Collection.js from dll-reference girder_lib
// module id = 45
// module chunks = 0